import { isEmpty } from 'lodash';

import { trackUxEvent } from 'util/tracking';
import { TRACK_ACTION_TYPES } from 'util/tracking_constants';

export const DISPLAY_ACTIONS = {
  SORT: 'sort',
  FILTER: 'filter',
  GROUP: 'group',
  HIDE: 'hide',
};

export const TIMESHEETS_MODAL_OPTIONS = {
  DETAILED: 'All Timecards',
  SUMMARY: 'Payroll Summary',
};

export const PRODUCT_AREAS = {
  TIMESHEETS: 'timesheets',
  PAYWALL: 'Paywall',
};

export const REGIONS = {
  TIMESHEETS_NAVIGATION: 'timesheets_navigation',
  TIMESHEETS_TABLE: 'timesheets_table',
};

export const TIMECARD_SELECT_INPUTS = {
  CLOCK_IN: 'clock_in',
  CLOCK_OUT: 'clock_out',
  ROLE: 'role',
  UNPAID_BREAK_END: 'unpaid_break_end',
  UNPAID_BREAK_START: 'unpaid_break_start',
  UNPAID_BREAK_TYPE: 'unpaid_break_type',
  PAID_BREAK_END: 'paid_break_end',
  PAID_BREAK_START: 'paid_break_start',
  PAID_BREAK_TYPE: 'paid_break_type',
};

export const TIMESHEETS_PRINT_VIEWS = {
  BY_DAY: 'timecards_by_day',
  BY_EMPLOYEE: 'timecards_by_employee',
  BY_ROLE: 'timecards_by_role',
  DEFAULT: 'default_view',
};

export const EVENT_CATEGORIES = {
  DOWNLOAD: 'Download',
  DOWNLOAD_TIMESHEETS_MODAL: 'Download Timesheets Modal',
  PAY_PERIOD_MENU: 'Pay Period Menu',
  PAYROLL_SUMMARY: 'Payroll Summary',
  PAYROLL_SUMMARY_DOWNLOAD_MODAL: 'Payroll Summary Download Modal',
  PAYROLL_SUMMARY_PRINT_BUTTON: 'Payroll Summary Print Button',
  PAYROLL_SUMMARY_SETTINGS: 'Payroll Summary Settings',
  TIMECARD_EDIT_HISTORY: 'Timecard Edit History',
  TIMESHEETS_PRINT_OPTION: 'Timesheets Print',
  TIMESHEETS: 'Timesheets',
  TIMESHEETS_PAYROLL_SUMMARY_INDIVIDUAL:
    'Timesheets - Payroll Summary Individual',
  TIMESHEETS_SETTINGS_DROPDOWN: 'Timesheets - Settings Dropdown',
  TIMESHEETS_MORE_ACTIONS_DROPDOWN: 'Timesheets - More Actions Dropdown',
  TIMESHEETS_TOOLS: 'timesheets_tools',
  TIMECARD_DETAILS: 'timecard_details',
  TIMESHEETS_ISSUES_SLIDER: 'Timesheets - Issues Slider',
  TIMESHEETS_PRINT_DRAWER: 'timesheets_print_drawer',
  TIMESHEETS_TABLE_HEADER: 'Timesheets - Table Header',
  TIMESHEETS_SUB_TABLES: 'Timesheets - Sub Tables',
  TIME_AND_PAY: 'time_and_pay',
  TIP_MANAGER_UNSUBSCRIBED: 'TIP_MANAGER_UNSUBSCRIBED',
};

export const EVENT_ACTIONS = {
  ADD_PAYROLL_PROVIDER_CLICKED: 'Add Payroll Provider Clicked',
  ADD_TIMECARD_BUTTON_CLICKED: 'Add timecard button clicked',
  ADD_TIMECARD_CLICKED: 'Add Timecard Clicked',
  APPLY_CLICKED: 'Apply Clicked',
  BREAK_PENALTY_CLICKED: 'Break Penalty Clicked',
  BUTTON_CLICKED: 'Button Clicked',
  CANCEL_CLICKED: 'Cancel Clicked',
  CASH_TIPS_CLICKED: 'Cash Tips Clicked',
  CLICK_COLUMN_DROPDOWN_MENU: 'Column Drop-down Menu Clicked',
  CLOSE_CLICKED: 'Close Clicked',
  COLLAPSE_CLICKED: 'Collapse Clicked',
  CURRENT_COLUMNS_CLICKED: 'Current Columns Clicked',
  CHANGE_CODE_CLICKED: 'Change Code Clicked',
  CREDIT_TIPS_CLICKED: 'Credit Tips Clicked',
  DATE_SELECTED: 'Date Selected',
  DELETE_CLICKED: 'Delete Clicked',
  DOWNLOAD_CLICKED: 'Download Clicked',
  DROPDOWN_MENU_CLICKED: 'Drop-down Menu Clicked',
  DISMISS_CLICKED: 'Dismiss Clicked',
  EDIT_COLUMNS_APPLY_CLICKED: 'Edit Columns - Apply Clicked',
  EDIT_COLUMNS_CANCEL_CLICKED: 'Edit Columns - Cancel Clicked',
  EDIT_COLUMNS_COLUMN_DESELECTED: 'Edit Columns - Column Deselected',
  EDIT_COLUMNS_COLUMN_MOVED: 'Edit Columns - Column Moved',
  EDIT_COLUMNS_COLUMN_SELECTED: 'Edit Columns - Column Selected',
  EDIT_COLUMNS_DROPDOWN_CLICKED: 'Edit Columns - Dropdown Clicked',
  EDIT_STATE_SHOWN: 'Timecard Edit State Shown',
  EVERYTHING_CLICKED: 'Everything Clicked',
  EXPAND_CLICKED: 'Expand Clicked',
  FILTER_BY_ALL_EMPLOYEES_SELECTED: 'Filter By - All Employees Selected',
  FILTER_BY_CLICKED: 'Filter by Clicked',
  FILTER_BY_EMPLOYEE_SELECTED: 'Filter By - Employee Selected',
  FILTER_TABLE_MENU_CLICKED: 'Filter Table Menu Clicked',
  FILTER_TIMESHEETS_CLICKED: 'Filter Timesheets Clicked',
  GROUP_BY_CLICKED: 'Group by Clicked',
  GROUP_BY_DATE_SELECTED: 'Group By - Date Selected',
  GROUP_BY_EMPLOYEE_SELECTED: 'Group By - Employee Selected',
  GROUP_BY_ROLE_SELECTED: 'Group By - Role Selected',
  HIDE_EMPLOYEES_CHECKBOX_CLICKED: 'Hide Employees Checkbox Clicked',
  IMPORT_TIMESHEETS_CLICKED: 'Import Timesheets Clicked',
  EXPORT_TIMESHEETS_CLICKED: 'Export Timesheets Clicked',
  EXPORT_TIMESHEETS_UPGRADE: 'Upgrade Clicked from Export Timesheets',
  INDIVIDUAL_LOCK_CLICKED: 'Individual Lock Clicked',
  INPUT_SELECTED: 'Input Selected',
  LINK_CLICKED: 'Link Clicked',
  LOCK_CLICKED: 'Lock Clicked',
  MESSAGE_CLICKED: 'Message Clicked',
  MORE_ACTIONS_CLICKED: 'More Actions Clicked',
  NEEDS_REVIEW_OPTIONS_CLICKED: 'Needs Review Options Clicked',
  NEXT_CLICKED: 'Next Clicked',
  NEXT_MONTH_ARROW_CLICKED: 'Next Month Arrow Clicked',
  OVERTIME_SETTINGS_CLICKED: 'Overtime Settings Clicked',
  PAGE_VIEWED: 'Page Viewed',
  PAY_PERIOD_MENU_CLICKED: 'Pay Period Menu Clicked',
  PAYROLL_SETTINGS_CLICKED: 'Payroll Settings Clicked',
  PREVIOUS_MONTH_ARROW_CLICKED: 'Previous Month Arrow Clicked',
  PRINT_CLICKED: 'Print Clicked',
  RESET_ALL_CLICKED: 'Reset All Clicked',
  ROW_HEADER_MENU_CLICKED: 'Row Header Menu Clicked',
  SAVE_CLICKED: 'Save clicked_v3',
  SCROLL_BUTTON_LEFT_CLICKED: 'Scroll Button Left Clicked',
  SCROLL_BUTTON_RIGHT_CLICKED: 'Scroll Button Right Clicked',
  SETTINGS_CLICKED: 'Settings Clicked',
  SORT_EMPLOYEE_FIRST_NAME_SELECTED: 'Sort Employees - First Name Selected',
  SORT_EMPLOYEE_LAST_NAME_SELECTED: 'Sort Employees - Last Name Selected',
  SORT_EMPLOYEES_BY_CLICKED: 'Sort Employees By Clicked',
  TIMECARD_ATTACHMENTS_CLICKED: 'Timecard Attachments Clicked',
  TIMECARD_CLICKED: 'Timecard Clicked',
  TIMECARD_CLOSED: 'Timecard Closed',
  TIP_MANAGER: 'Tip Manager',
  UNLOCK_CLICKED: 'Unlock Clicked',
  EXPAND_ALL_CLICKED: 'Expand all Clicked',
  COLLAPSE_ALL_CLICKED: 'Collapse all Clicked',
  VIEW_TIMESHEETS_CLICKED: 'View Timesheets Clicked',
  VIEW: 'View',
};

const STARTING_PATHS = {
  DASHBOARD: 'dashboard',
  TIMESHEETS: 'timesheets',
};

export const TRACKABLE_PATHNAMES = {
  '/dashboard/location': STARTING_PATHS.DASHBOARD,
  '/timesheets': STARTING_PATHS.TIMESHEETS,
};

export const getPropertiesExperiment = ({ properties, experiment }) => {
  if (experiment) {
    properties.experiment = experiment;
  }

  return properties;
};

export const trackEditModeShown = ({ eventAction, properties }) => {
  trackUxEvent({
    eventAction,
    eventCategory: EVENT_CATEGORIES.TIMECARD_DETAILS,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.VIEW,
    properties,
  });
};

export const trackColumnHeaderClick = ({ columnName, experiment = null }) => {
  const properties = {
    column_name: columnName,
  };

  trackUxEvent({
    eventAction: EVENT_ACTIONS.CLICK_COLUMN_DROPDOWN_MENU,
    eventCategory: EVENT_CATEGORIES.TIMESHEETS_TABLE_HEADER,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackColumnMenuActionClick = ({
  columnName,
  action,
  experiment = null,
}) => {
  const properties = {
    column_name: columnName,
  };

  trackUxEvent({
    eventAction: action,
    eventCategory: EVENT_CATEGORIES.TIMESHEETS_TABLE_HEADER,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackTableRowHeaderClick = ({ action, experiment = null }) => {
  const properties = {};

  trackUxEvent({
    eventAction: action,
    eventCategory: EVENT_CATEGORIES.TIMESHEETS_SUB_TABLES,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackTableRowClick = ({ action, experiment = null }) => {
  const properties = {};

  trackUxEvent({
    eventAction: action,
    eventCategory: EVENT_CATEGORIES.TIMESHEETS,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackFilterTableClick = ({
  action,
  experiment = null,
  properties = {},
}) => {
  trackUxEvent({
    eventAction: action,
    eventCategory: EVENT_CATEGORIES.TIMESHEETS_TOOLS,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackFilterTableEditColumn = ({
  action,
  category,
  properties = {},
  experiment = null,
}) => {
  trackUxEvent({
    eventAction: action,
    eventCategory: category,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackDownloadTimesheetsModal = ({
  action,
  properties = {},
  experiment = null,
}) => {
  trackUxEvent({
    eventAction: action,
    eventCategory: EVENT_CATEGORIES.DOWNLOAD_TIMESHEETS_MODAL,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackUxNavigationEvent = ({
  action,
  category,
  properties = {},
  experiment = null,
}) => {
  if (experiment) {
    getPropertiesExperiment({ properties, experiment });
  }

  const trackingData = {
    productArea: PRODUCT_AREAS.TIMESHEETS,
    eventCategory: category,
    eventAction: action,
    actionType: TRACK_ACTION_TYPES.CLICK,
  };

  if (!isEmpty(properties)) {
    trackingData.properties = properties;
  }

  trackUxEvent(trackingData);
};

export const trackPayPeriodMenuClick = ({ action, experiment = null }) => {
  const properties = {};
  trackUxEvent({
    eventAction: action,
    eventCategory: EVENT_CATEGORIES.PAY_PERIOD_MENU,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackPayrollSummaryDownloadModal = ({
  action,
  experiment = null,
}) => {
  const properties = {};
  trackUxEvent({
    eventAction: action,
    eventCategory: EVENT_CATEGORIES.PAYROLL_SUMMARY_DOWNLOAD_MODAL,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties: getPropertiesExperiment({ properties, experiment }),
  });
};

export const trackDropDownMenuClick = ({ properties = {} }) => {
  trackUxEvent({
    eventAction: EVENT_ACTIONS.DROPDOWN_MENU_CLICKED,
    eventCategory: EVENT_CATEGORIES.TIMECARD_DETAILS,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties,
  });
};

export const trackDropDownDeleteClicked = ({ properties = {} }) => {
  trackUxEvent({
    eventAction: EVENT_ACTIONS.DELETE_CLICKED,
    eventCategory: EVENT_CATEGORIES.TIMECARD_DETAILS,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties,
  });
};

export const trackDropDownInputSelected = ({ properties = {} }) => {
  trackUxEvent({
    eventAction: EVENT_ACTIONS.INPUT_SELECTED,
    eventCategory: EVENT_CATEGORIES.TIMECARD_DETAILS,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties,
  });
};

export const trackTimecardClick = ({ eventAction, properties }) => {
  trackUxEvent({
    eventAction,
    eventCategory: EVENT_CATEGORIES.TIMECARD_DETAILS,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties,
  });
};

export const trackRoleSelectInput = (field, value) => {
  if (field === 'role_id') {
    const dropDownProp = TIMECARD_SELECT_INPUTS.ROLE;
    if (value === '') {
      trackDropDownDeleteClicked({
        properties: { drop_down: dropDownProp },
      });
    } else {
      trackDropDownInputSelected({
        properties: { drop_down: dropDownProp },
      });
    }
  }
};

export const trackPrintTSDrawer = ({ eventAction, properties = {} }) => {
  const trackingData = {
    eventAction,
    eventCategory: EVENT_CATEGORIES.TIMESHEETS_PRINT_DRAWER,
    productArea: PRODUCT_AREAS.TIMESHEETS,
    actionType: TRACK_ACTION_TYPES.CLICK,
  };

  if (!isEmpty(properties)) {
    trackingData.properties = properties;
  }

  trackUxEvent(trackingData);
};

export const trackToggleIssuesSlider = () => {
  const trackingData = {
    productArea: PRODUCT_AREAS.TIMESHEETS,
    eventCategory: EVENT_CATEGORIES.TIMESHEETS_SUB_TABLES,
    eventAction: EVENT_ACTIONS.NEEDS_REVIEW_OPTIONS_CLICKED,
    actionType: TRACK_ACTION_TYPES.CLICK,
  };

  trackUxEvent(trackingData);
};

const trackTimePayZeroStateEvent = (eventAction, actionType, properties) => {
  const trackingData = {
    productArea: PRODUCT_AREAS.TIMESHEETS,
    eventCategory: EVENT_CATEGORIES.TIME_AND_PAY,
    eventAction,
    actionType,
    properties,
  };

  trackUxEvent(trackingData);
};

export const trackTimecardModalClose = properties => {
  const trackingData = {
    productArea: PRODUCT_AREAS.TIMESHEETS,
    eventCategory: EVENT_CATEGORIES.TIMECARD_DETAILS,
    eventAction: EVENT_ACTIONS.TIMECARD_CLOSED,
    actionType: TRACK_ACTION_TYPES.CLICK,
    properties,
  };

  trackUxEvent(trackingData);
};

export const trackTimePayZeroStateClick = linkText =>
  trackTimePayZeroStateEvent(
    EVENT_ACTIONS.LINK_CLICKED,
    TRACK_ACTION_TYPES.CLICK,
    {
      link_text: linkText,
    }
  );

export const trackTimePayZeroStateShown = () =>
  trackTimePayZeroStateEvent(
    EVENT_ACTIONS.PAGE_VIEWED,
    TRACK_ACTION_TYPES.VIEW
  );
